import * as React from 'react';
import * as I18n from 'i18n-js';
import { ButtonDisplayRecommendations } from './button_display_recommendations';
import { CoreBumpRecommendationListingCard } from '../../schemas/rql';
import { BumpDescription } from './bump_description';
import { IUser } from '@reverbdotcom/commons/dist/components/user_context_provider';
import { useUser } from '@reverbdotcom/commons/dist/user_hooks';
import { MParticleEventName } from '@reverbdotcom/commons/dist/elog/mparticle_types';
import { trackEvent } from '@reverbdotcom/commons/dist/elog/mparticle_tracker';

const COMPONENT_NAME = 'BumpModalContainer';

interface Props {
  bid: number;
  handleBidChange: (bid: number) => void;
  listing: CoreBumpRecommendationListingCard.Fragment;
  recommendationAmount: number;
  selectedBid: number;
  successMessage: string;
  failMessage: string;
  updateBid: (
    bid: number,
    bumpRecommendationAmount: number,
    listing: CoreBumpRecommendationListingCard.Fragment,
    user: Partial<IUser>,
  ) => void;
}

export function BumpV2Modal(props: Props) {
  const [enableBump, setEnableBump] = React.useState(!!props.bid);
  const user = useUser();

  React.useEffect(() => {
    trackEvent({
      componentName: COMPONENT_NAME,
      eventName: MParticleEventName.ViewedBumpSlider,
      listing: props.listing,
      startingBumpRatePercent: (props.bid * 100),
      bumpRecommendationPercent: props.recommendationAmount,
    });
  });

  // when the user toggles the label, it will set their bump bid
  const handleLabelClick = () => {
    setEnableBump(!enableBump);

    // if the user is disabling the slider, delete bump by setting it to 0
    // otherwise pass along the recommendationAmount as their initial bid
    const bumpAmount = !enableBump ? props.recommendationAmount : 0;

    const amount = bumpAmount / 100;

    // recommendationAmount is returned as a percent, ie 3.5 for 3.5%
    // however the bump API requires values in decimal ie 0.035
    props.updateBid(
      amount,
      props.recommendationAmount,
      props.listing,
      user,
    );
    props.handleBidChange(amount);
  };

  return (
    <>
      <BumpDescription
        listing={props.listing}
      />
      <div className="bump-modal__switch">
        <input
          type="checkbox"
          checked={enableBump}
          readOnly
        />
        <label
          onClick={
            () => {
              handleLabelClick();
            }
          }
        >
          {I18n.t('discovery.bumpModalV2.enableBumpCheckbox')}
        </label>
      </div>
      {
        props.successMessage && <div
          className="color-green mt-1"
        >
          {props.successMessage}
        </div>
      }
      {
        props.failMessage && <div
          className="color-red mt-1"
        >
          {props.failMessage}
        </div>
      }
      {
        enableBump &&
        <ButtonDisplayRecommendations
          bid={props.bid}
          handleBidChange={props.handleBidChange}
          listing={props.listing}
          recommendationAmount={props.recommendationAmount}
          selectedBid={props.selectedBid}
          updateBid={props.updateBid}
        />
      }
    </>
  );
}



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/src/components/bump/bump_v2_modal.tsx